import { render, staticRenderFns } from "./MultilangInput.vue?vue&type=template&id=8f5f5abc&scoped=true&"
import script from "./MultilangInput.vue?vue&type=script&lang=js&"
export * from "./MultilangInput.vue?vue&type=script&lang=js&"
import style0 from "./MultilangInput.vue?vue&type=style&index=0&id=8f5f5abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5f5abc",
  null
  
)

export default component.exports